import { ethers } from "ethers";
import { get, writable } from 'svelte/store';
import {target_network, target_mainnet} from "./wallet";

export let provider_infura = null;
export let provider_infura_socket = null;
export let infura_ready = writable(false);

const INFURA_APIKEY = "";
// const network = "homestead";
// const network = "ropsten";
const network = target_network.name;

async function init(){
    // if(network === "ganache"){
    //     provider_infura =
    //     provider_infura_socket = await new ethers.providers.JsonRpcProvider("http://localhost:8545");
    //     infura_ready.set(true);
    //     readyFunc();
    //     return;
    // }
    //
    // provider_infura = await new ethers.providers.InfuraProvider(network,INFURA_APIKEY);
    // provider_infura_socket = await new ethers.providers.InfuraWebSocketProvider(network,INFURA_APIKEY);
    // infura_ready.set(true);
    // readyFunc();
}

let readyFunc = ()=>{};
export function onReady(func){
    readyFunc = func;
}

init();

